import { render, staticRenderFns } from "./ProfileGeneralInfo.vue?vue&type=template&id=867f4636&scoped=true"
import script from "./ProfileGeneralInfo.vue?vue&type=script&lang=js"
export * from "./ProfileGeneralInfo.vue?vue&type=script&lang=js"
import style0 from "./ProfileGeneralInfo.vue?vue&type=style&index=0&id=867f4636&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "867f4636",
  null
  
)

export default component.exports